import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Text } from '@common-fe/common-fe';

import { CompleteVerificationMessage } from '@/modules/core/components/Dashboard/components/BannersList/CompleteBanner';
import { ElectronicAgreementMessage } from '@/modules/transaction/components/Statements/components/ElectronicAgreementMessage';
import { HEADERS, StatementsList } from '@/modules/transaction/components/Statements/components/StatementsList';
import { useOrganizationProperties } from '@/modules/transaction/hooks';
import useMyEnrollments from '@/modules/transaction/hooks/useMyEnrollments';

const Statements = () => {
  const { t } = useTranslation();
  const { organizationProperties } = useOrganizationProperties();
  const { mainHSAEnrollment } = useMyEnrollments();
  const accountId = mainHSAEnrollment?.id;
  const headers = useMemo(() => [HEADERS[0]], []);

  return (
    <Box data-testId="statements-tab">
      <CompleteVerificationMessage margin={{ bottom: 'spacing24' }} />
      <ElectronicAgreementMessage margin={{ bottom: 'spacing24' }} />
      <StatementsList accountId={accountId} headers={headers} />
      <Text margin={{ top: 'spacing24' }} color="textSecondary">
        {t('For any questions, please contact us at ')}{organizationProperties?.customerServiceEmail}
      </Text>
    </Box>
  );
};

export default Statements;
